/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/digital-menu-share-customers';

export const DigitalMenuShareCustomerApi = {
  findByMenuID: async (
    menuID: string,
    options: FindDigitalMenuShareCustomerOptions
  ) => {
    let url = `${pathname}/menu/${menuID}`;
    const query = serialize({ ...options });
    url += query;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  shareWithCustomerFromMenu: async (
    menuID: string,
    body: ShareMenuShareWithCustomerBody
  ) => {
    const url = `${pathname}/menu/${menuID}/with-customer`;

    try {
      return await entityService.post(url, body);
    } catch (error) {
      throw error;
    }
  },

  createCustomerAndShareFromMenu: async (
    menuID: string,
    body: CreateCustomerAndShareMenuShareBody
  ) => {
    const url = `${pathname}/menu/${menuID}`;

    try {
      return await entityService.post(url, body);
    } catch (error) {
      throw error;
    }
  },

  updateDigitalMenuShare: async (
    menuShareCustomerID: string,
    body: UpdateMenuShareForCustomerBody
  ) => {
    const url = `${pathname}/${menuShareCustomerID}`;

    try {
      return await entityService.patch(url, body);
    } catch (error) {
      throw error;
    }
  },

  removePricePolicy: async (digitalMenuShareCustomerID: string) => {
    const url = `${pathname}/${digitalMenuShareCustomerID}/remove-policy`;

    try {
      return await entityService.patch(url);
    } catch (error) {
      throw error;
    }
  },

  delete: async (digitalMenuShareCustomerID: string) => {
    const url = `${pathname}/${digitalMenuShareCustomerID}`;

    try {
      return await entityService.delete(url);
    } catch (error) {
      throw error;
    }
  },
};

export interface ShareMenuShareWithCustomerBody {
  customerID: string;
}

export interface UpdateMenuShareForCustomerBody {
  digitalMenuShareID?: string;
  entityPricePolicyID?: string;
}

export interface CreateCustomerAndShareMenuShareBody {
  avatar: string;
  fullName: string;
  phoneNumber: string; // chỉ chấp nhận dạng "+84...."
  address: string;
  provinceCode: string;
  districtCode: string;
  wardCode: string;
}

export interface FindDigitalMenuShareCustomerOptions extends FindOptions {
  userID?: string;
}
